import Request from '@/utils/request'

// 巴西 葡萄牙 19.99充值活动
export function apiNineteenDotNinetyNineAct (params) {
  return Request({
    url: '/api/v2/app/shop/activity/3/cfg',
    method: 'get',
    params
  })
}